module.exports = __webpack_public_path__ + "static/media/sernies.501c77a8.jpeg";